import ApiService from './api.service';

export interface CustomDisplayFormat {
  id: string;
  label: string;
  d3_format: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
}

interface ListResponse {
  records: CustomDisplayFormat[];
  total_records: number;
  total_pages: number;
}

interface SingleResponse {
  record: CustomDisplayFormat;
}

export interface CustomDisplayFormatInput {
  label: string;
  d3_format: string;
}

export class CustomDisplayFormatService {
  async list(): Promise<CustomDisplayFormat[]> {
    const result = (await ApiService.getInstance().request(
      'GET',
      '/custom-display-formats',
    )) as ListResponse;
    return result.records;
  }

  async create(data: CustomDisplayFormatInput): Promise<CustomDisplayFormat> {
    const result = (await ApiService.getInstance().request(
      'POST',
      '/custom-display-formats',
      data,
    )) as SingleResponse;
    return result.record;
  }

  async update(id: string, data: CustomDisplayFormatInput): Promise<CustomDisplayFormat> {
    const result = (await ApiService.getInstance().request(
      'PATCH',
      `/custom-display-formats/${id}`,
      data,
    )) as SingleResponse;
    return result.record;
  }

  async delete(id: string): Promise<void> {
    await ApiService.getInstance().request('DELETE', `/custom-display-formats/${id}`);
  }
}

export const customDisplayFormatService = new CustomDisplayFormatService();
